<div class="flx-modal" role="dialog" aria-modal="true" aria-labelledby="assignTitle">
    <div class="flx-modal__header">
        <h2 id="assignTitle">{{translate?.asset.sections.sec9.singular}}</h2>
        <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="flx-modal__body">
        <div class="flex-align-center flex-column">
            <span *ngIf="data?.addon?.addonQRSCANFORM != 'QR_SCAN_FORM' && data?.page === 'Asset'">
                <app-barcode-generator *ngIf="barCodeType !== 'QR Generator'" [barCodeType]="barCodeType" [value]="data?.assetData?.serialNo"></app-barcode-generator>
                <app-qr-generator *ngIf="barCodeType === 'QR Generator'" [value]="data?.assetData?.serialNo"  [width]="190"></app-qr-generator>
            </span>

            <span *ngIf="data?.addon?.addonQRSCANFORM === 'QR_SCAN_FORM' && data?.page === 'Asset'">
                <app-qr-generator [value]="data?.assetData?.encryptedTenantId" [width]="190"></app-qr-generator> 
            </span>

             <span *ngIf="data?.page === 'Site' && data?.siteData?.siteCode">
                <app-qr-generator  [value]="valueQR"  [width]="190"></app-qr-generator>
            </span>

           
            <label class="field-label">{{valueQRToDisplay}}
              <i class="fa-regular fa-clone hvr" id="icon_AssetOverviewJobOrdCopyBarcode" [pTooltip]="copyText" (click)="copySerialNo(valueQR)" tooltipPosition="right"></i>
            </label>
        </div>
    </div>

    <div class="flx-modal__footer">
    <button pButton icon="fa-regular fa-download" [label]="translate?.general.buttons.download.singular" class="p-button-outlined p-button-secondary h-32" (click)="downloadQRCode()"></button>
    </div>
</div>
